import { FEATURES } from '/src/features/_global/constants';

export const EDITOR_PERMISSIONS = {
  [FEATURES.EDITOR]: ({ capabilities }) => ({
    navigate: capabilities?.editor.permissions.nav,
  }),
};
